import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { isEmpty } from 'lodash'

const useFetchImages = (urls) => {
  const [images, setImages] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const history = useHistory()

  useEffect(() => {
    if (isEmpty(urls)) {
      setError('URLs are required')
      setLoading(false)
      return null
    }

    const timestamp = new Date().getTime()

    const fetchData = async () => {
      setLoading(true)
      try {
        let results = await Promise.allSettled(
          urls.map(({ url }) => {
            return axios.get(`${url}.webp?${timestamp}`, {
              responseType: 'blob',
            })
          })
        )

        let images = {}
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            images[urls[index]?.uuid] = result.value.data ?? null
          }
        })
        setImages(images)
      } catch (error) {
        setError(error)
      } finally {
        setLoading(false)
        history.push({
          state: {
            ...history.location.state,
            updatedItemUuid: null,
          },
        })
      }
    }

    fetchData()
  }, [urls?.length, history])

  return { images, loading, error }
}

export default useFetchImages
